import React, { useState } from 'react';

import css from './LaborAndToolsItemTypesInfoStep3.module.css';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { LaborAndToolsItemsTypesSection } from '@modules/Steps/Shared/Ui/Wrappers/LaborAndToolsItemsTypesSection/LaborAndToolsItemsTypesSection';
import { LaborAndToolsItemsTypesHeaderStep3 } from '@modules/Steps/Components/Step3/Step3DesktopContent/LaborAndToolsItemsTypesInfoStep3/LaborAndToolsItemsTypesHeaderStep3/LaborAndToolsItemsTypesHeaderStep3';
import { ItemsCheckedListTable } from '@modules/Steps/Components/Step3/Step3DesktopContent/FragmentInfoStep3/ItemsCheckedListTable/ItemsCheckedListTable';
import { FragmentInfoFooterStep3 } from '@modules/Steps/Components/Step3/Step3DesktopContent/FragmentInfoStep3/FragmentInfoFooterStep3/FragmentInfoFooterStep3';
import { ItemTypesListMobile } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/ItemTypesListMobile/ItemTypesListMobile';
import { StepNumberEnum } from '@modules/Steps/Shared/Enums/StepNumberEnum';
import { ItemsSelectionViewModel } from '@viewModels/ItemsSelectionViewModel/ItemsSelectionViewModel';
import { FragmentsViewModel } from '@viewModels/FragmentsViewModel/FragmentsViewModel';
import { useItemsSelectionStore } from '../../../../../../Stores/ItemsSelectionStore';

interface Props {
    title: string;
    description: string;
    itemTypes: ItemTypeEntity[];
    disabledButtons?: boolean;
}

export const LaborAndToolsItemTypesInfoStep3: React.FC<Props> = ({
    title,
    description,
    itemTypes,
    disabledButtons,
}) => {
    const selectedItemsViewModel = new ItemsSelectionViewModel();
    const fragmentsViewModel = new FragmentsViewModel();
    const { selectedItems } = useItemsSelectionStore();

    const [isExpanded, setIsExpanded] = useState(false);
    const [isDesktop] = useMediaType();

    const toggleExpand = () => {
        setIsExpanded(prev => !prev);
    };

    const totalPrice = fragmentsViewModel.getItemTypesTotal(itemTypes);
    const selectedTotal =
        selectedItemsViewModel.getSelectedTotalByItemTypes(itemTypes);

    return (
        <LaborAndToolsItemsTypesSection>
            <LaborAndToolsItemsTypesHeaderStep3
                title={title}
                description={description}
                itemTypes={itemTypes}
                toggleExpand={toggleExpand}
                expanded={isExpanded}
                disabledButtons={disabledButtons}
            />
            {isDesktop ? (
                <>
                    <ItemsCheckedListTable itemTypes={itemTypes} />
                    <FragmentInfoFooterStep3
                        grandTotal={totalPrice}
                        selectedTotal={selectedTotal}
                    />
                </>
            ) : (
                <div
                    className={`${css.laborAndToolsItemTypesMobile} ${isExpanded ? css.showLaborAndTools : ''}`}
                >
                    <ItemTypesListMobile
                        itemTypes={itemTypes}
                        stepNumber={StepNumberEnum.STEP3}
                    />
                    <FragmentInfoFooterStep3
                        grandTotal={totalPrice}
                        selectedTotal={selectedTotal}
                    />
                </div>
            )}
        </LaborAndToolsItemsTypesSection>
    );
};
